import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Reminder } from '../models/models';

@Component({
  selector: 'app-new-reminder-modal',
  templateUrl: './new-reminder-modal.component.html',
  styleUrls: ['./new-reminder-modal.component.scss']
})
export class NewReminderModalComponent implements OnInit {
  @Input() parentReminder: Reminder;
  @Input() isUnaffiliated = false;
  @Input() companyId: number = null;
  @Input() companyName: string = null;
  
  newReminderModel: Partial<Reminder> = {
    id: 0,
    note: '',
    followUpDate: new Date(),
    isResolved: false,
    priority: 3,
    parentReminderID: null,
    companyID: null,
    createdDate: new Date(),
    createdByUserID: 0
  };
  
  priorityOptions = [
    { value: 4, label: 'Low' },
    { value: 3, label: 'Medium' },
    { value: 2, label: 'High' },
    { value: 1, label: 'Urgent' }
  ];

  private defaultReminderNoteTableName = 'Company'; 
  private defaultReminderNoteTypeId = 1; 
  
  constructor(
    public activeModal: NgbActiveModal,
    private toastr: ToastrService
  ) { }

  ngOnInit() {
    if (this.parentReminder) {
      this.newReminderModel.parentReminderID = this.parentReminder.id;
      this.newReminderModel.companyID = this.parentReminder.companyID;
      this.newReminderModel.documentID = this.parentReminder.documentID;
    } else if (this.companyId !== null) {
      this.newReminderModel.companyID = this.companyId;
    }
    
    if (this.isUnaffiliated) {
      this.newReminderModel.companyID = null;
    }
  }
  
  saveNewReminder(): void {
    if (!this.newReminderModel.note || !this.newReminderModel.followUpDate) {
      this.toastr.warning('Note and Follow-up Date are required');
      return;
    }
    
    this.newReminderModel.noteTableName = this.defaultReminderNoteTableName; 
    this.newReminderModel.noteTypeID = this.defaultReminderNoteTypeId; 
    this.newReminderModel.recordID = this.newReminderModel.companyID; 
    
    this.activeModal.close(this.newReminderModel);
  }
  
  dismiss(): void {
    this.activeModal.dismiss('cancel');
  }
  
  getPriorityLabel(priority: number | undefined): string {
    if (!priority) { return 'None'; }
    
    const priorityOption = this.priorityOptions.find(option => option.value === priority);
    return priorityOption ? priorityOption.label : 'None';
  }
}



// WEBPACK FOOTER //
// ./src/app/core/components/reminders/new-reminder-modal/new-reminder-modal.component.ts